import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/app/[locale]/pos-system-hospitality/PosGuidePage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedc5c185aba8d/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
